













import Vue, { PropOptions } from 'vue';

export type Bulletpoint = Blok & {
  label: string;
  customIcon: BlokFieldAsset;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Bulletpoint>,
  },
});
